const addHoverListener = (map) => {
  map.data.addListener('mouseover', (event) => {
    map.data.revertStyle()
    map.data.overrideStyle(event.feature, { fillOpacity: 0.8 })
  })

  map.data.addListener('mouseout', () => {
    map.data.revertStyle()
   // map.data.overrideStyle(event.feature, { fillOpacity: 0.6 })
  })
}

export default addHoverListener



// WEBPACK FOOTER //
// ./src/mapSetup/addHoverListener.js